export default __webpack_public_path__ + "static/media/Croc5.2744fb9a.png";